<template>
  <div
    class="row border text-center"
    :class="{ [`border-${statusClass}`]: !noStatus, round }"
    :style="{
      backgroundColor: bgColor,
      height: autoHeight ? 'auto' : `${size + (denseDefault ? 0 : 8)}px`,
      width: `${(url || !defaultSize ? size : defaultSize) + (denseDefault ? 0 : 8)}px`,
      borderWidth: `${borderWidth}px`,
    }"
  >
    <q-img
      v-if="url"
      class="image"
      :class="{ round }"
      data-t="image"
      spinner-color="primary"
      :spinner-size="`${size}px`"
      :src="url"
      :style="{ height: autoHeight ? 'auto' : `${size}px`, width: `${size}px` }"
    >
      <template #error>
        <DefaultImage :dense="denseDefault" :size="defaultSize || size" :type="type" />
      </template>
      <slot />
    </q-img>
    <DefaultImage v-else :dense="denseDefault" :size="defaultSize || size" :type="type" />
  </div>
</template>

<script>
import DefaultImage from 'components/DefaultImage.vue';
import { fit } from 'src/services/cloudinary';
import { ASSET_TYPES, statusColorClasses } from 'src/services/constants';

export default {
  props: {
    autoHeight: Boolean,
    bgColor: {
      type: String,
      default: 'white',
    },
    borderWidth: {
      type: Number,
      default: 3,
    },
    defaultSize: Number,
    denseDefault: Boolean,
    full: Boolean,
    height: Number,
    noStatus: Boolean,
    round: {
      type: Boolean,
      default: true,
    },
    size: Number,
    status: {
      type: String,
      default: 'STOPPED',
    },
    type: String,
    url: String,
    width: Number,
  },
  components: {
    DefaultImage,
  },
  computed: {
    cloudinaryUrl() {
      return fit(this.url, { width: this.size * 2, height: this.size * 2 });
    },
    statusClass() {
      return statusColorClasses[this.status];
    },
    isVehicle() {
      return this.type === ASSET_TYPES.VEHICLE;
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-style: solid;
  padding: 1px;

  &.round {
    border-radius: 100%;
  }
}

.image {
  max-height: 100%;

  &.round {
    border-radius: 50%;
  }
}
</style>
